import {
    OBTENER_SERVICE_PROFILES,
    OBTENER_SERVICE_PROFILE,
    MARCA_ERROR,
    MARCA_OK,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_SERVICE_PROFILES:
            return {
                ...state,
                serviceProfiles: action.payload
            }
        case OBTENER_SERVICE_PROFILE:
            return {
                ...state,
                serviceProfile: action.payload
            }
        case MARCA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MARCA_OK:
            return {
                ...state,
                mensaje: action.payload
            }       
        default:
            return state;
    }
}